import React from 'react';
import styles from '../../styles/match-event-placeholders.module.scss'
import classNames from "classnames";
import {MatchEventModulePlaceholderRow} from "./match-event.module.placeholder.row";

export const MatchEventModulePlaceholderEvents = ({eventsNum}) => {
  let events: Array<Number> = [];

  for(let i=0; i<eventsNum; i++){
    events.push(i)
  }

  return (
    <div className={classNames(styles.events)} style={{height: eventsNum*40}}>
      {
        events.map((num: Number) => <MatchEventModulePlaceholderRow key={num}/>)
      }
    </div>
  )
};
